import { forEach, reduce, reject } from 'lodash/collection';
import { isEmpty, isNil } from 'lodash/lang';
import { findKey, has } from 'lodash/object';

import {
  getFieldLabel,
  optionUsedInConditionalLogicModalConfirmation
} from '../../../../services/conditionalLogicUtils';

export function getFieldsUpdater(changeRequests, optionFieldName, callback) {
  return function updater(fields) {
    return fields.map(function(field) {
      const changeRequest = changeRequests[field.name];
      if (changeRequest) {
        const nextFieldConfigurationResponse = reject(
          field.fieldConfigurationResponse.map(function(condition) {
            if (condition.conditionFieldName === optionFieldName) {
              const nextConditionFieldAnswerNames = reject(
                condition.conditionFieldAnswerNames.map(function(optionName) {
                  if (has(changeRequest, optionName)) {
                    return changeRequest[optionName];
                  }
                  return optionName;
                }),
                isNil
              );
              if (isEmpty(nextConditionFieldAnswerNames)) {
                return null;
              }
              return { ...condition, conditionFieldAnswerNames: nextConditionFieldAnswerNames };
            }
            return condition;
          }),
          isNil
        );
        return { ...field, fieldConfigurationResponse: nextFieldConfigurationResponse };
      }
      return callback(field);
    });
  };
}

export function handleIfOptionLinkedToFields(tableSetupContext, optionFieldName, params) {
  return confirmBeforeDelete(generateChangeRequests(tableSetupContext, optionFieldName, params), params.optionName);
}

function confirmBeforeDelete(changeRequests, optionName) {
  if (!changeRequests) {
    return Promise.resolve();
  }

  const { affectedFieldLabels, optionNextName } = changeRequests;

  if (optionNextName) {
    return Promise.resolve(changeRequests);
  }

  return optionUsedInConditionalLogicModalConfirmation(affectedFieldLabels, optionName).then(
    () => {
      return changeRequests;
    },
    error => {
      throw error;
    }
  );
}

function generateChangeRequests(
  tableSetupContext,
  optionFieldName,
  { optionName, optionNextName = null, changeRequests }
) {
  const fieldsLinkedByOption = [];

  const optionOriginName = reduce(
    changeRequests,
    function(accumulator, r) {
      const optionOriginName = findKey(r, v => v === optionName);
      if (optionOriginName) {
        return optionOriginName;
      }
      return accumulator;
    },
    optionName
  );

  throughAllFields(tableSetupContext, function(field) {
    throughFieldConditions(field, function({ conditionFieldName, conditionFieldAnswerNames }) {
      if (conditionFieldName === optionFieldName && conditionFieldAnswerNames.includes(optionOriginName)) {
        fieldsLinkedByOption.push(field);
      }
    });
  });

  if (isEmpty(fieldsLinkedByOption)) {
    return;
  }

  return {
    affectedFieldNames: fieldsLinkedByOption.map(field => field.name),
    affectedFieldLabels: fieldsLinkedByOption.map(field => getFieldLabel(field)),
    optionOriginName,
    optionNextName
  };
}

function throughAllFields({ generalFields, fieldList }, callback) {
  forEach({ generalFields, fieldList }, function(definitionList) {
    definitionList.forEach(callback);
  });
}

function throughFieldConditions(field, callback) {
  const configurationList = field.fieldConfigurationResponse;
  if (!configurationList) {
    return;
  }
  configurationList.forEach(callback);
}
